export default __webpack_public_path__ + "static/logo-full-light-d88387be7b1c8457de05c2b8df77fcca.svg";